const initialCreateConsentRequestValues = {
	customerId: '',
	consentDesc: '',
	template: '',
	purpose: {
		code: '',
		text: '',
		refUri: '',
		Category: {
			type: '',
		},
	},
	consentMode: '',
	fiType: [],
	consentType: [],
	frequency: '',
	frequencyPeriod: {
		value: '',
		unit: '',
	},
	consentStart: {
		value: '',
		unit: '',
	},
	consentExpiry: {
		value: '',
		unit: '',
	},
	dataLife: {
		value: '',
		unit: '',
	},
	dataRange: {
		value: '',
		unit: '',
	},
	dataFilter: {
		type: '',
		operator: '',
		value: '',
	},
};

export default initialCreateConsentRequestValues;
